<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="time"
        append-icon="mdi-clock-time-four-outline"
        readonly
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
      />
    </template>
    <v-card>
      <v-time-picker
        v-model="time"
        full-width
        format="24hr"
        scrollable
        @click:minute="$refs.menu.save(time)"
      />
      <div>
        <v-text-field v-model="time" class="px-4" />
      </div>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: { value: String },
  data() {
    return {
      time: this.value,
      menu: false,
    };
  },
  watch: {
    time(value) {
      this.$emit("input", value);
    },
    value(value) {
      this.time = value;
    },
  },
};
</script>
